<template>
  <v-container fluid class="pa-1">
    <v-row dense>
      <v-col cols="12">
        <v-container>
          <v-row v-if="loading" justify="center" dense>
            <v-col>
              <div class="text-center">
                <v-chip class="ma-2" color="primary">
                  Procesando Información ...
                </v-chip>
              </div>
              <div class="text-center">
                <v-progress-circular
                  :size="70"
                  :width="7"
                  color="green"
                  indeterminate
                ></v-progress-circular>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
      <v-col cols="12">
        <v-snackbar
          v-model="mensaje.snack"
          :timeout="mensaje.tiempo"
          :color="mensaje.snackColor"
          top
          right
        >
          {{ mensaje.snackText }}
          <template v-slot:action="{ attrs }">
            <v-btn text v-bind="attrs" @click="mensaje.snack = false">
              <v-icon dark>mdi-close-box</v-icon>
            </v-btn>
          </template>
        </v-snackbar>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "cerrarApp",
  components: {},
  data: () => ({
    loading: true,
    mensaje: {
      snack: false,
      snackColor: "",
      snackText: "",
      tiempo: 2000,
    },
  }),
  created() {
    //console.log(this.$route.params.cerrar);
    console.log("saliendo del sistema...");
    this.btnSalir("saliendo del sistema...");
  },
  methods: {
    apiSalir(val) {
      return new Promise((resolve, reject) => {
        //console.log(val);
        resolve(val);
      });
    },
    async btnSalir(val) {
      try {
        this.loading = true;
        const respuesta = await this.APIverificaEnlace(val);
        if (respuesta) {
          this.$store.dispatch("salir");
        }
      } catch (error) {
        if (error.response === null || error.response === undefined) {
          this.mensaje.snackColor = "grey darken-4";
          this.mensaje.snackText = error;
          this.mensaje.snack = true;
        } else {
          this.mensaje.snackColor = "red darken-4";
          this.mensaje.snackText = await this.$store.dispatch(
            "errorMensaje",
            error.response
          );
          this.mensaje.snack = true;
        }
        this.$store.dispatch("salir");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
